// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateMemoModalDocumentsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DocumentWhereInput>;
}>;


export type CreateMemoModalDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType, displayType: string } | null } | null> | null } };

export const Operations = {
  Query: {
    CreateMemoModalDocuments: 'CreateMemoModalDocuments' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateMemoModalDocumentsDocument = gql`
    query CreateMemoModalDocuments($where: DocumentWhereInput) {
  documents(where: $where, orderBy: [{field: created_at, direction: DESC}]) {
    edges {
      node {
        id
        name
        type
        displayType
      }
    }
  }
}
    `;

/**
 * __useCreateMemoModalDocumentsQuery__
 *
 * To run a query within a React component, call `useCreateMemoModalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateMemoModalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateMemoModalDocumentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCreateMemoModalDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<CreateMemoModalDocumentsQuery, CreateMemoModalDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateMemoModalDocumentsQuery, CreateMemoModalDocumentsQueryVariables>(CreateMemoModalDocumentsDocument, withFetchPolicyContext(options));
      }
export function useCreateMemoModalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateMemoModalDocumentsQuery, CreateMemoModalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateMemoModalDocumentsQuery, CreateMemoModalDocumentsQueryVariables>(CreateMemoModalDocumentsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCreateMemoModalDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateMemoModalDocumentsQuery, CreateMemoModalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateMemoModalDocumentsQuery, CreateMemoModalDocumentsQueryVariables>(CreateMemoModalDocumentsDocument, withFetchPolicyContext(options));
        }
export type CreateMemoModalDocumentsQueryHookResult = ReturnType<typeof useCreateMemoModalDocumentsQuery>;
export type CreateMemoModalDocumentsLazyQueryHookResult = ReturnType<typeof useCreateMemoModalDocumentsLazyQuery>;
export type CreateMemoModalDocumentsSuspenseQueryHookResult = ReturnType<typeof useCreateMemoModalDocumentsSuspenseQuery>;
export type CreateMemoModalDocumentsQueryResult = Apollo.QueryResult<CreateMemoModalDocumentsQuery, CreateMemoModalDocumentsQueryVariables>;